import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";


const ContractsPopupNextIndicator = (props) => {

  const {top, pageOffsetLeft, handleNextIndicatorClick, text } = props;

  const style = {
    left: pageOffsetLeft - 60,
    top,
  }

  return (
    <div className='contract-body-indicator contract-body-indicator-next'
         style={style}
         onClick={handleNextIndicatorClick}>
      <FormattedMessage id={text || "contractSign.fillInText"}/>
    </div>
  )
};

ContractsPopupNextIndicator.propTypes = {
  top: PropTypes.number,
  pageOffsetLeft: PropTypes.number,
  handleNextIndicatorClick: PropTypes.func.isRequired,
}

export default ContractsPopupNextIndicator
